import { render, staticRenderFns } from "./BatteryInfo.vue?vue&type=template&id=bcedaf52&scoped=true"
import script from "./BatteryInfo.vue?vue&type=script&lang=js"
export * from "./BatteryInfo.vue?vue&type=script&lang=js"
import style0 from "./BatteryInfo.vue?vue&type=style&index=0&id=bcedaf52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcedaf52",
  null
  
)

export default component.exports